import React from 'react';
import { CRow, CCol, CCard, CPlaceholder } from '@coreui/react';
import { InfoSkeleton } from '../SkeletonDetails';

const ProjectInfoCard = ({ isLoading, dataProyecto, id, nombreProyecto, cliente, operador, descripcion, fechaCreacion, fechaInicio, fechaFin }) => {
    if (isLoading && !dataProyecto) return <InfoSkeleton />;
    return (
        <CCard className="premium-card p-0 shadow-sm border-0" style={{ borderRadius: '16px', overflow: 'hidden' }}>
            <div className="px-4 py-3 border-bottom" style={{ background: 'linear-gradient(to right, #f8f9fa, #ffffff)' }}>
                <h5 className="mb-0 fw-bold" style={{ color: '#131133', fontSize: '1.1rem', letterSpacing: '-0.3px' }}>
                    <span className="me-2" style={{ color: '#3d99eb' }}>■</span>Detalles del Proyecto
                </h5>
            </div>
            <div className="p-4">
                <CRow className="g-4">
                    {/* Basic Info */}
                    <CCol md={6}>
                        <div className="d-flex flex-column gap-3">
                            <div className="d-flex align-items-center">
                                <div className="rounded-circle d-flex align-items-center justify-content-center me-3" style={{ width: '40px', height: '40px', backgroundColor: 'rgba(61, 153, 235, 0.1)', color: '#3d99eb' }}>
                                    <span style={{ fontSize: '1.2rem' }}>🏷️</span>
                                </div>
                                <div>
                                    <span className="text-uppercase text-muted fw-bold d-block mb-1" style={{ fontSize: '0.65rem', letterSpacing: '0.5px' }}>Nombre / ID</span>
                                    <span className="fw-bold text-dark d-block" style={{ fontSize: '1rem' }}>{nombreProyecto || 'N/A'} <span className="text-muted fw-normal" style={{ fontSize: '0.8rem' }}>#{id}</span></span>
                                </div>
                            </div>

                            <div className="d-flex align-items-center">
                                <div className="rounded-circle d-flex align-items-center justify-content-center me-3" style={{ width: '40px', height: '40px', backgroundColor: 'rgba(88, 86, 214, 0.1)', color: '#5856D6' }}>
                                    <span style={{ fontSize: '1.2rem' }}>🏢</span>
                                </div>
                                <div>
                                    <span className="text-uppercase text-muted fw-bold d-block mb-1" style={{ fontSize: '0.65rem', letterSpacing: '0.5px' }}>Cliente</span>
                                    <span className="fw-semibold text-dark d-block" style={{ fontSize: '0.95rem' }}>{cliente || 'N/A'}</span>
                                </div>
                            </div>

                            <div className="d-flex align-items-center">
                                <div className="rounded-circle d-flex align-items-center justify-content-center me-3" style={{ width: '40px', height: '40px', backgroundColor: 'rgba(46, 184, 92, 0.1)', color: '#2eb85c' }}>
                                    <span style={{ fontSize: '1.2rem' }}>⚙️</span>
                                </div>
                                <div>
                                    <span className="text-uppercase text-muted fw-bold d-block mb-1" style={{ fontSize: '0.65rem', letterSpacing: '0.5px' }}>Operador</span>
                                    <span className="fw-semibold text-dark d-block" style={{ fontSize: '0.95rem' }}>{operador || 'N/A'}</span>
                                </div>
                            </div>
                        </div>
                    </CCol>

                    {/* Dates */}
                    <CCol md={6}>
                        <div className="p-3 border rounded-3 bg-light d-flex flex-column gap-3 h-100">
                            <h6 className="fw-bold text-dark mb-0" style={{ fontSize: '0.85rem', letterSpacing: '0.5px' }}>LÍNEA DE TIEMPO</h6>
                            <div className="border-bottom pb-2">
                                <span className="text-uppercase text-muted fw-bold d-block mb-1" style={{ fontSize: '0.65rem', letterSpacing: '0.5px' }}>Fecha Creación</span>
                                <span className="fw-semibold text-dark">{fechaCreacion || 'N/A'}</span>
                            </div>
                            <div className="d-flex justify-content-between">
                                <div>
                                    <span className="text-uppercase text-muted fw-bold d-block mb-1" style={{ fontSize: '0.65rem', letterSpacing: '0.5px' }}>Inicio Ejecución</span>
                                    <span className="fw-bold text-success" style={{ fontSize: '0.9rem' }}>{fechaInicio || 'N/A'}</span>
                                </div>
                                <div className="text-end">
                                    <span className="text-uppercase text-muted fw-bold d-block mb-1" style={{ fontSize: '0.65rem', letterSpacing: '0.5px' }}>Fin Ejecución</span>
                                    <span className="fw-bold text-danger" style={{ fontSize: '0.9rem' }}>{fechaFin || 'N/A'}</span>
                                </div>
                            </div>
                        </div>
                    </CCol>

                    {/* Description */}
                    <CCol xs={12}>
                        <div className="mt-2">
                            <span className="text-uppercase text-muted fw-bold d-block mb-2" style={{ fontSize: '0.65rem', letterSpacing: '0.5px' }}>Descripción del Proyecto</span>
                            <div className="bg-white p-3 rounded-3 border" style={{ borderLeft: '4px solid #131133' }}>
                                <span className="text-dark" style={{ fontSize: '0.9rem', lineHeight: '1.5' }}>
                                    {descripcion || 'Sin descripción disponible.'}
                                </span>
                            </div>
                        </div>
                    </CCol>
                </CRow>
            </div>
        </CCard>
    );
};

export default React.memo(ProjectInfoCard);
